import { AxiosError, AxiosRequestConfig } from 'axios';
import { apiGet, apiPost, apiDelete } from './api';
import { IOrganizationCoupon, ICreateOrganizationCoupon } from '../types/coupons.types';
const { REACT_APP_ORGANIZATION } = process.env;

/**
 * Obtiene los cupones de una organización
 * @param organizationId ID de la organización
 * @returns Lista de cupones de la organización
 */
export const getOrganizationCoupons = async (organizationId: number): Promise<IOrganizationCoupon[]> => {
  return apiGet<AxiosRequestConfig, IOrganizationCoupon[]>(
    `${REACT_APP_ORGANIZATION}/organization-coupon/organization/${organizationId}?includeExpired=false&includeUsed=true`
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

/**
 * Crea un nuevo cupón para una organización
 * @param couponData Datos del cupón a crear
 * @returns Cupón creado o null si hubo un error
 */
export const createOrganizationCoupon = async (couponData: ICreateOrganizationCoupon): Promise<IOrganizationCoupon> => {
  return apiPost<AxiosRequestConfig, ICreateOrganizationCoupon>(
    `${REACT_APP_ORGANIZATION}/organization-coupon`,
    couponData
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

/**
 * Elimina un cupón de una organización
 * @param couponId ID del cupón a eliminar
 * @returns true si se eliminó correctamente, false en caso contrario
 */
export const deleteOrganizationCoupon = async (couponId: number): Promise<boolean> => {
  return apiDelete<AxiosRequestConfig, number>(`${REACT_APP_ORGANIZATION}/organization-coupon/${couponId}`)
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};
